<template>
	<svg
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xml:space="preserve"
		:viewBox="icons[name].viewBox"
		y="0px"
		x="0px"
		preserveAspectRatio="xMidYMid meet"
		class="icon"
		:class="{[`icon-${name}`]: true}"
	>
		<g :transform="icons[name].transform">
			<app-play-circle v-if="name === 'play-circle'" />
			<path v-else v-for="(path, key) in icons[name].paths"
				:key="key"
				:d="path"
				:fill="color"
			/>
		</g>
	</svg>
</template>

<script>
	import PlayCircle from './icons/playCircle.vue'

	import { arrowDown } from './icons/arrowDown'
	import { arrowLeft } from './icons/arrowLeft'
	import { arrowRight } from './icons/arrowRight'
	import { close } from './icons/close'
	import { envelope } from './icons/envelope'
	import { fullscreenContract } from './icons/fullscreenContract'
	import { fullscreenExpand } from './icons/fullscreenExpand'
	import { home } from './icons/home'
	import { homeWide } from './icons/homeWide'
	import { house } from './icons/house'
	import { pause } from './icons/pause'
	import { pdf } from './icons/pdf'
	import { phone } from './icons/phone'
	import { pin } from './icons/pin'
	import { play } from './icons/play'
	import { playCircle } from './icons/playCircle.js'
	import { search } from './icons/search'
	import { volumeHigh } from './icons/volumeHigh'
	import { volumeLow } from './icons/volumeLow'
	import { volumeMute } from './icons/volumeMute'
	import { volumeOff } from './icons/volumeOff'

	export default {
		components: {
			appPlayCircle: PlayCircle
		},
		props: {
			name: {
				default: 'house',
				type: String
			},
			color: {
				default: '#231f20',
				type: String
			}
		},
		data () {
			return {
				icons: {
					close,
					envelope,
					home,
					house,
					pause,
					pdf,
					phone,
					pin,
					play,
					search,
					'arrow-down': arrowDown,
					'arrow-left': arrowLeft,
					'arrow-right': arrowRight,
					'fullscreen-contract': fullscreenContract,
					'fullscreen-expand': fullscreenExpand,
					'play-circle': playCircle,
					'home-wide': homeWide,
					'volume-high': volumeHigh,
					'volume-low': volumeLow,
					'volume-mute': volumeMute,
					'volume-off': volumeOff				
				}
			}
		}
	}
</script>

<style lang="scss">
	.icon {
		width: 1.5625rem;
	}
</style>
